<template>
  <div>
    <form @submit.prevent="onSubmit">
      <div class="container">
        <div>
          <img
            v-show="isloginProgress"
            src="../assets/loading.gif"
            style="margin-left: 30%;"
          >
        </div>
        <span
          v-show="error"
          class="error"
        >{{ errMsg }}</span>
        <img
          src="../assets/jd-logo-large-en.png"
          class="jd_logo"
        >
        <label for="uname">
          <b>Office Email ID</b>
        </label>
        <input
          v-model="userName"
          type="text"
          placeholder="Enter Office Email ID"
          name="uname"
          required
        >
        <label for="psw">
          <b>Password</b>
        </label>
        <input
          v-model="password"
          type="password"
          placeholder="Enter Password"
          name="psw"
          required
        >
        <button
          type="submit"
          class="submit-button"
          @keyup.enter.native="loginCheck()"
          @click="loginCheck()"
        >
          Login
        </button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: 'Login',
  data() {
    return {
      userName: '',
      password: '',
      errMsg: '',
      isloginProgress: false,
      error: false,
    };
  },
  methods: {
    onSubmit() {},
    loginCheck() {
      const vm = this;
      vm.error = false;
      if (vm.userName === '') {
        vm.error = true;
        vm.errMsg = 'Please Enter User Name';
        return true;
      }
      if (vm.password === '') {
        vm.error = true;
        vm.errMsg = 'Please Enter Password';
        return true;
      }
      vm.isloginProgress = true;
      const url = '/api/login/';
      vm.obj = {
        userName: this.userName,
        password: this.password,
      };
      fetch(url, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify(vm.obj), // data can be `string` or {object}!
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
      })
        .then(res => {
          if (res.status === 200) {
            return res.json();
          } else {
            // Reload current page to ensure cookies are cleared.
            window.location.reload(true);
          }
        })
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then((response) => {
          if (response.errorCode === 0 && response.message === 'Success') {
            vm.$router.push({ name: 'prepareMailers' });
          } else {
            vm.error = true;
            vm.errMsg = 'Invalid User/Password';
          }
          vm.isloginProgress = false;
        });
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.jd_logo {
  margin: 2rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  filter: invert(100%);
}

.error {
  color: red;
  display: block;
  width: 100%;
  margin: auto;
  text-align: center;
}

form {
  width: 40%;
  margin: auto;
  margin-top: 5rem;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: block;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

button {
  background-color: #3ca23c;
  color: white;
  padding: 14px 20px;
  margin: auto;
  display: block;
  border: none;
  cursor: pointer;
  width: 30%;
}

button:hover {
  opacity: 0.8;
}

.imgcontainer {
  text-align: center;
  margin: 24px 0 12px 0;
}

img.avatar {
  width: 40%;
  border-radius: 50%;
}

.container {
  padding: 16px;
}

span.psw {
  float: right;
  padding-top: 16px;
}

/* Change styles for span and cancel button on extra small screens */
@media screen and (max-width: 700px) {
  form {
    width: 100%;
    margin: auto;
  }

  span.psw {
    display: block;
    float: none;
  }

  .cancelbtn {
    width: 100%;
  }
}
</style>
